import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DATE_FORMAT } from 'src/app/core/constants/date';
import { Patient } from 'src/app/core/models/patient';
import { CustomDatePipe } from 'src/app/core/pipes/custom-date.pipe';
import { MemberInformationService } from 'src/app/core/services/member-information.service';
import { PatientService } from 'src/app/core/services/patient.service';
import { formatIndividualName } from 'src/app/core/utils/autocomplete-util';

type LayoutType = 'form-left-right-column' | 'form-full-width-column' | 'form-full-width-inline-column';

@Component({
  selector: 'th-member-details',
  templateUrl: './member-details.component.html',
  styleUrls: ['./member-details.component.scss']
})
export class MemberDetailsComponent implements OnInit, OnDestroy {
  @Input() labelColumnClass: string;
  @Input() inputColumnClass: string;
  @Input() memberId: string;
  @Input() layoutType: LayoutType = 'form-left-right-column';
  @Input() showNameDOBField = true;

  @Input()
  @HostBinding('class.use-form-wrapper')
  set useFormWrapperClasses(useFormWrapperClasses: boolean) {
    this._useFormWrapperClasses = useFormWrapperClasses;

    this.initializeFormGroupClassMap();
  }

  get useFormWrapperClasses(): boolean {
    return this._useFormWrapperClasses;
  }

  formGroupClasses: { [cssClass: string]: boolean };

  memberIdSubscription: Subscription;
  nameAndDOB: string;
  patient: Patient;
  loading = false;

  private _useFormWrapperClasses = true;

  constructor(
    private patientService: PatientService,
    private memberInformationService: MemberInformationService,
    private datePipe: CustomDatePipe
  ) {}

  ngOnInit() {
    if (this.memberId) {
      this.getPatientDetails();
    } else {
      this.memberIdSubscription = this.memberInformationService.memberId.subscribe((memberId) => {
        this.memberId = memberId;

        this.getPatientDetails();
      });
    }

    this.initializeFormGroupClassMap();
  }

  ngOnDestroy() {
    this.memberIdSubscription?.unsubscribe();
  }

  private initializeFormGroupClassMap() {
    this.formGroupClasses = {
      'form-group': this.useFormWrapperClasses,
      'form-row': this.useFormWrapperClasses
    };
  }

  private getPatientDetails() {
    this.loading = true;

    this.patientService
      .getPatient(this.memberId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((patient) => {
        const formattedDate = this.datePipe.transform(patient.dob, DATE_FORMAT, 'UTC');
        this.nameAndDOB = `${formatIndividualName(patient)} / ${formattedDate || 'UNK'}`;
        this.patient = patient;
      });
  }
}
